import styled from 'styled-components';
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0;
  padding: 16px;
  color: rgb(0 0 0 / 88%);
  position: relative;
  background: #fff;
  border-radius: 8px;
`;
export const Title = styled.div`
  font-weight: 600;
  line-height: 22px;
`;
export const Content = styled.div`
  display: block;
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;
export const Cell = styled.div`
  flex: 1;
`;
export const Label = styled.div`
  color: #777;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
`;
export const Value = styled.div`
  color: #1f1f1f;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
`;
